import React from "react";
import { FEATURES } from "../data/content";
import Icon from "./Icon";
import "../styles/features.css";

function FeaturesGrid({ withHighlight = true }) {
  return (
    <>
      <div className="features-grid">
        {FEATURES.map((f) => (
          <div className="features-card" key={f.name}>
            <div className="features-icon">
              <Icon name={f.iconKey} size={22} />
            </div>
            <h3 className="features-name">{f.name}</h3>
            <p className="features-detail">{f.detail}</p>
          </div>
        ))}
      </div>

      {withHighlight && (
        <div className="features-highlight" id="late-minute-policy">
          <div className="features-highlight-copy">
            <span className="mono-tag features-highlight-tag">
              Late-Minute Deduction Policy
            </span>
            <h3 className="features-highlight-title">
              Automated late-minute salary deduction
            </h3>
            <p className="features-highlight-text">
              Late attendance is evaluated against a configured threshold of
              90 minutes. Once an employee&rsquo;s accumulated late minutes
              for the applicable period exceed 90 minutes, a half-day salary
              deduction is applied — and for every additional block of 90
              minutes of lateness, a further half-day deduction is applied
              cumulatively. The rule runs automatically during payroll
              processing, and the resulting deduction is itemized on the
              employee&rsquo;s payslip.
            </p>
          </div>
          <div className="features-highlight-visual" aria-hidden="true">
            <div className="features-rule-row">
              <span className="features-rule-block">0–90 min</span>
              <span className="features-rule-arrow">→</span>
              <span className="features-rule-result">No deduction</span>
            </div>
            <div className="features-rule-row">
              <span className="features-rule-block features-rule-block--alert">&gt;90 min</span>
              <span className="features-rule-arrow">→</span>
              <span className="features-rule-result features-rule-result--alert">Half-day deduction</span>
            </div>
            <div className="features-rule-row">
              <span className="features-rule-block features-rule-block--alert">+90 min more</span>
              <span className="features-rule-arrow">→</span>
              <span className="features-rule-result features-rule-result--alert">+Half-day, cumulative</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FeaturesGrid;
